import React, { createContext, useContext, useState } from "react";

export const ChatContext = createContext(null);
